
import {SignUp} from "@clerk/clerk-react"
function Signup(){
    return(
        <div className=" w-full h-full flex justify-center items-center"><SignUp></SignUp></div>
        
    )
}
export default Signup